import { render, staticRenderFns } from "./redirectToWeb.vue?vue&type=template&id=2eec6099&scoped=true&"
import script from "./redirectToWeb.vue?vue&type=script&lang=js&"
export * from "./redirectToWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eec6099",
  null
  
)

export default component.exports